import React , { Component } from "react";
import fire from "./config/fire";
import Paper from '@material-ui/core/Paper';

import AccountCircle from '@material-ui/icons/AccountCircle';

import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';

class Login extends Component{
constructor(props)
{
    super(props);
    this.login = this.login.bind(this);
    this.forgotpassword = this.forgotpassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.signup = this.signup.bind(this);
    this.state={
        email : "",
        password : "",
        err:""
    }
}
login(e){
    e.preventDefault();
    fire.auth().signInWithEmailAndPassword(this.state.email,this.state.password).then((u)=>{
        console.log(u)
    }).catch((err)=>{
        console.log(err);
        this.setState({err: "Enter valid Email/Password for Login!!!"});
    })
}
signup(e){
    e.preventDefault();
    fire.auth().createUserWithEmailAndPassword(this.state.email,this.state.password).then((u)=>{
        console.log(u)
    }).catch((err)=>{
        console.log(err);
        this.setState({err: "Enter valid Email/Password for Signup!!!"})
    })
}
forgotpassword(e){
    e.preventDefault();
    fire.auth().sendPasswordResetEmail(this.state.email).then((u)=>{
        console.log(u)
        this.setState({err: "Password reset link is sent to your account !!!"})
    }).catch((err)=>{
        console.log(err);
        this.setState({err: "Enter Email address to reset password !!!"})
    })
}
handleChange(e){
    this.setState({
        [e.target.name] : e.target.value
    })
}
render()
{
    return(
        <div >
            {/* <Paper elevation={3} >
            <form>
                <input
                type="email"
                id="email"
                name="email"
                placeholder="enter email address"
                onChange={this.handleChange}
                value={this.state.email}
                />
                <br/>
                <input
                name="password"
                type= "password"
                onChange={this.handleChange}
                id="password"
                placeholder="enter password"
                value={this.state.password}
                />
                <br/>
                <button onClick={this.login}>Login</button>
                <button onClick={this.signup}>Signup</button>
                <br/>
                <button onClick={this.forgotpassword}>Forgot password</button>
                <br/>
                <span style={{color:"red"}}>{this.state.err}</span>
            </form> */}
        {/* </Paper> */}
        <center>
            <img src="./WatchAnyMovieLogo.png"  width="50" height="50" style={{marginTop:"50px"}}alt="logo"></img>
            <br/>
            <br/>
            <p style={{color:"white"}}>Developed by Amol Dalwai</p>
            <br/>
        <Paper elevation={3} style={{width:"80%",padding:"20px",backgroundColor:"#313131"}} >
          <br/>
        <Fab
            color="primary"
            
            style={{
              background: "#b71c1c",
              borderRadius: "5px",
              
              height: "45px"
            }}
          
          >
            <AccountCircle  />
          </Fab>
            <input
            type="email"
            placeholder="Type in your Email"
            style={{
              height: "45px",
              width: "190px",
              borderRadius: "5px",
              paddingLeft: "10px",
              color: "white",
              background: "#212121",
              border: "2px",
              marginTop:"10px",
            }}
            
            id="email"
            name="email"
            
            onChange={this.handleChange}
            value={this.state.email}
          />
          <br/> <br/>
          <Fab
            color="primary"
            
            style={{
              background: "#b71c1c",
              borderRadius: "5px",
              
              height: "43px"
            }}
          
          >
            <VpnKeyIcon />
          </Fab>
          <input
            type="password"
            // value={stext}
            placeholder="Type in your password"
            style={{
              height: "45px",
              width: "190px",
              borderRadius: "5px",
              paddingLeft: "10px",
              color: "white",
              background: "#212121",
              border: "2px",
            }}
            name="password"
           
            onChange={this.handleChange}
            id="password"
            
            value={this.state.password}
          />
          
       <br/>
       <br/>
        <span style={{color:"red"}}>{this.state.err}</span>
        <br/>
       <br/>
        <Button  onClick={this.login} style={{backgroundColor:"#b71c1c",marginRight:"5px",color:"white",width:"120px"}} >
         Login 
        </Button>
        <Button  onClick={this.signup} style={{backgroundColor:"#b71c1c",color:"white",width:"120px"}} >
         Signup
        </Button>
        <br/>
        <br/>
        <u style={{color:"red"}} onClick={this.forgotpassword} >Forgot Password ?</u>

        
        </Paper>
       </center>
       
        </div>
    )
}
}
export default Login;